








































import { Vue, Component, Watch } from "vue-property-decorator";
import Header from "@/components/Main/Header.vue";
import MapView from "@/components/Main/MapView.vue";
import Footer from "@/components/Main/Footer.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { StoreModule } from "@/store/types";
import { GlobalGetters, GlobalActions } from "@/store/modules/global/types";
import { namespace } from "vuex-class";
import { RepActions } from "@/store/modules/rep/types";
import {
  CustomerActions,
  CustomerGetters,
} from "@/store/modules/customer/types";
import { UserActions, UserGetters } from "@/store/modules/user/types";
import { SalesRegions, SalesRegionsStringType } from "@/models/map/region_type";
import { Roles } from "@/models/roles";
import simplebar from "simplebar-vue";
import Sidebar from "@/components/Main/Sidebar.vue";
import ActivityHistory from "@/components/Main/Charts/ActivityHistory.vue";
import { EventBus } from "@/events/index";
import RepService from "@/services/rep_service";
import CustomerService from "@/services/customer_service";
import { ActivitySchema } from "@/models/activity_schema";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import DraggableDiv from "@/components/Main/DraggableDiv.vue";
import AuthService from "@/services/auth_service";
@Component({
  components: {
    Header,
    MapView,
    Footer,
    Loading,
    simplebar,
    Sidebar,
    ActivityHistory,
    DraggableDiv,
  },
})
export default class Main extends Vue {
  protected region: SalesRegionsStringType | "" = "";
  protected Roles = Roles;
  protected repService = new RepService();
  protected customerService = new CustomerService();
  protected authService = new AuthService();
  protected notes: ActivitySchema[] | null = null;
  protected show = false;
  protected selectedId: string | null = null;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetLoading)) isLoading;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetLoggedIn)) isLoggedIn;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddLoggedIn))
  addLoggedIn;
  @(namespace(StoreModule.Rep).Action(RepActions.AddAllReps)) addReps;
    @(namespace(StoreModule.Rep).Action(RepActions.ClearReps)) clearReps;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.User).Getter(UserGetters.GetUser)) user;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddLoading)) setLoading;
  @(namespace(StoreModule.Customer).Action(CustomerActions.AddAllCustomers))
  addCustomers;
  @(namespace(StoreModule.User).Getter(UserGetters.GetSalesRegion))
  assignedRegion;
  @(namespace(StoreModule.User).Action(UserActions.AddUser)) addUser;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;
  @(namespace(StoreModule.Rep).Action(RepActions.SetSelectedRep))
  addActiveRep;

  async created() {
    this.setLoading(true);
    await this.checkAuth();
    if (this.role === Roles.SalesRep) {
      await this.clearReps();
      if (this.$route.name === 'customerslist' || this.$route.name === 'repslist') {
      await this.fetchCustomers(this.assignedRegion);
      }
    } else if (this.role === Roles.Unverified || this.role === Roles.RetailerLevel1 || this.role === Roles.Removed) {
      this.addLoggedIn(false);
      this.addUser({});
      await this.authService.logout();
      this.$router.push("/error");
    } else {
      this.addActiveRep({});
      if (this.$route.name === 'repslist') {
      await this.fetchReps();
      }
      if (this.$route.name === 'customerslist' || this.$route.name === 'repslist') {
      await this.fetchCustomers();
      }
    }
  }

  protected async checkAuth(): Promise<void> {
    try {
      const user: any = await this.authService.checkAuth();
      this.addLoggedIn(true);
      this.addUser(user);
    } catch (err) {
      this.addLoggedIn(false);
      this.addUser({});
      this.$router.push("/login");
    }
  }

  mounted() {
    EventBus.$on(
      "showActivityHistory",
      (show: boolean, id: string, type: "customers" | "reps") => {
        if (id && type === "reps") {
          this.fetchRepActivityNotes(id, show);
        } else if (id && type === "customers") {
          this.fetchCustomerActivityNotes(id, show);
        } else {
          this.show = show;
        }
      }
    );
  }

  beforeDestroy() {
    EventBus.$off('showActivityHistory');
  }


  /**
   * @param show boolean true triggers the graph popup
   */
  public async fetchRepActivityNotes(id: string, show: boolean): Promise<void> {
    try {
      const res = await this.repService.getRepActivities(id);
      this.notes = res;
      this.show = show;
      this.selectedId = id;
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  /**
   * @param show boolean true triggers the graph popup
   */
  public async fetchCustomerActivityNotes(
    id: string,
    show: boolean
  ): Promise<void> {
    try {
      const res = await this.customerService.getCustomerActivities(id);
      this.notes = res;
      this.show = show;
      this.selectedId = id;
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public async fetchReps(): Promise<void> {
    try {
      await this.addReps();
    } catch (err) {
      if (err instanceof APIError) {
        // not including auth error here, or else we'll get 2 popups if the session is expired (customers request triggers one too)
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public async fetchCustomers(region?: SalesRegions["string"]): Promise<void> {
    try {
      await this.addCustomers(region);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  private get showLoader(): boolean {
    return this.isLoading;
  }

  private setRegion(region: SalesRegions["string"] | ""): void {
    this.region = region;
  }
}
